export const configModes =
{
    0: 'Configure by type',
    1: 'Configure by group'
};